import { css } from 'linaria';

export const designStudioBenefitsSection = css`
  && {
    margin-top: 80px;

    @media (--to-desktop) {
      margin-top: 64px;
    }

    @media (--only-mobile) {
      margin-top: 40px;
    }
  }
`;

export const benefitsList = css`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  padding: 0;
  margin: 0;
  column-gap: 24px;
  list-style: none;

  @media (--only-tablet) {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 104px);
    column-gap: 16px;
    row-gap: 16px;
  }

  @media (--only-mobile) {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    column-gap: 0;
    row-gap: 16px;
  }
`;

export const benefitText = css`
  display: block;
  width: 200px;
  margin-top: 16px;
`;
